import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { i18nIntl, isNotEmpty } from '../../lib/ep.js';

import StageMosaicItem from '../../components/front/StageMosaicItem.js';
import PromoColsWrapper from '../../components/front/PromoColsWrapper.js';
import { localizeFields } from '../../components/builder/DynamicFields.js';
import { StageSection } from '../../components/front/StageMosaic.js';
import { useFilterData } from '../../components/FilterContent.js';

const GalleryMosaic = ({ stages, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const loaded_img = true;

	const goToStage = (promotion_id, stage_id) => {
		window.location.href = `/gallery/${promotion_id}/${stage_id}`;
	};

	const getStagesInSection = (all_stages, section, jury_list, sections_enabled) => {
		if(jury_list == undefined) jury_list = false;

		return all_stages.filter((obj) => {
			const is_jury = (obj.Stage.voting_jury_mode != undefined) ? obj.Stage.voting_jury_mode : false;
			if(is_jury && !jury_list) return false;
			if(!is_jury && jury_list) return false;
			
			if(section.id == 'no_section' && (!sections_enabled || obj.Stage.section_id == undefined)) return true;
			return (obj.Stage.section_id == section.id) ? true : false;
		});
	};

	const promo = props?.promotion ?? {};
	const is_builder = props?.is_builder ?? false;
		
	const stages_to_display = stages;

	const [ state, dispatch ] = useFilterData(stages);

	let sections_enabled = (promo.sections_enabled != undefined) ? promo.sections_enabled : false;
	const has_no_section = (getStagesInSection(stages_to_display, { id:'no_section' }, false, sections_enabled).length > 0) ? true : false;

	if(promo.stage_sections != undefined) {
		promo.stage_sections = localizeFields(promo.stage_sections, props.locale);
	}

	const stage_sections = (sections_enabled && promo.stage_sections != undefined) ? ((has_no_section) ? [...promo.stage_sections, { id:'no_section', title:i18n("No section"), is_empty:true }] : promo.stage_sections) : [{ id:'no_section' }];
	if(sections_enabled && stage_sections.length == 1) sections_enabled = false;

	const default_description_text = `<h1>${i18n("Galleries")}</h1><p>${i18n("Click on the stage you want to participate in. The stage must be open.")}</p>`;
	const stages_description = (isNotEmpty(promo, 'galleries_description')) ? promo.galleries_description : default_description_text;

	let main_image = (promo?.galleries_image ?? false) ? promo.full_galleries_image : false;
	let main_video = promo?.galleries_video ?? false;

	const site_layout = promo?.stages_mosaic_layout ?? 'mosaic';	// "mosaic" / "list"
	const image_proportion = (site_layout == 'mosaic') ? (promo?.stages_mosaic_image_proportion ?? 'landscape') : 'squared';

	let animation_type = false;

	const container_class = ['gui_multiparticipation_landing', `images_${image_proportion}`, `is_${site_layout}`];
	if(stages.length > 0) {
		if(stages.length == 2 || stages.length == 4) container_class.push('col_double');
		if((promo.stages_mosaic_hide_stage_border != undefined && promo.stages_mosaic_hide_stage_border) || site_layout == 'list') container_class.push('without_context');

		animation_type = (promo.stages_mosaic_open_animation != undefined && promo.stages_mosaic_open_animation != 'none') ? promo.stages_mosaic_open_animation : false;
		if(animation_type) {
			container_class.push(`is_animated ${animation_type}_animated`);
			if(animation_type == 'window') {
				const animation_anchor_point = promo?.stages_mosaic_open_animation_anchor ?? 'left';
				container_class.push(`${animation_anchor_point}_anchor`);
			}
		}
	}

	return (
		<PromoColsWrapper
			main_image={main_image}
			main_video={main_video}
			main_description={stages_description}
		>
			{stage_sections.map((section, index) => {
				return (
					<StageSection
						key={`section_${index}`}
						section={section}
						state={state}
						promo={promo}
						search_value=''
						is_builder={is_builder}
						container_class={container_class}
						sections_enabled={sections_enabled}
						stages_to_display={stages_to_display}
						loaded_img={loaded_img}
						participations={props.participations}
						goToStage={goToStage}
						getStagesInSection={getStagesInSection}
					/>
				)
			})}
		</PromoColsWrapper>
	)
};

export default injectIntl(GalleryMosaic);